import Axios from 'axios'
import { defined, not } from 'junctions-fp'

const API_URI = process.env.NODE_ENV === 'development' ? 'http://localhost:4000' : 'https://api.pixel.swello.com/v2'
const UPLOAD_URI = API_URI + '/medias'
const SETTINGS_URI = API_URI + '/me'
const TEMPLATE_URI = SETTINGS_URI + '/templates'
const IMAGE_PROVIDER = `https://l8h7sc1nre.execute-api.eu-west-1.amazonaws.com/prod/`

/**
 * @class HttpConnector
 */
export default class HttpConnector {
  static __INSTANCE
  constructor(token = '') {
    this.__ME_HEADERS = defined(token)
      ? {
          headers: {
            Authorization: token
          }
        }
      : {}
  }

  static getInstance(token) {
    if (not(defined(this.__INSTANCE))) {
      this.__INSTANCE = new HttpConnector(token)
    }
    return this.__INSTANCE
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////
  // TEMPLATE
  //////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * Récupère un ou plusieurs template.
   * Si id n'est pas definit récupère l'ensemble des templates
   *
   * @param {any} [id=null] identifiant du template a récupérer si null alors on récupère l'ensemble des templates
   * @returns {array} un tableau de template
   * @memberof HttpConnector
   */
  async getTemplates(id = null) {
    let uri = id ? `${TEMPLATE_URI}/${id}` : TEMPLATE_URI
    let result = []
    try {
      result = await Axios.get(uri, this.__ME_HEADERS)
      return result.data
    } catch (e) {
      return []
    }
  }

  /**
   * Sauvegarde un template
   *
   * @param {any} data les information sur le template
   * @returns {Object} retour la ressource créer par l'api
   * @memberof HttpConnector
   */
  async saveTemplate(data) {
    try {
      data.template = JSON.stringify(data.template)
      const result = await Axios.post(TEMPLATE_URI, data, this.__ME_HEADERS)
      result.data.template = JSON.parse(result.data.template)
      return result.data
    } catch (e) {
      throw new Error('saveError')
    }
  }

  /**
   * Supprime un template
   *
   * @param {any} data l'objet template, on récupère l'id de l'objet pour la suppression
   * @returns {Object} retourne la ressource supprimé
   * @memberof HttpConnector
   */
  async deleteTemplate(data) {
    try {
      return await Axios.delete(`${TEMPLATE_URI}/${data.id}`, this.__ME_HEADERS)
    } catch (e) {
      throw new Error('deleteError')
    }
  }

  /**
   * Met à jour un template
   *
   * @param {any} data l'objet template, on récupère l'id de l'objet pour la mise a jour
   * @returns {Object} retourne la ressource modifié
   * @memberof HttpConnector
   */
  async updateTemplate(data) {
    try {
      data.template = JSON.stringify(data.template)
      const result = await Axios.put(`${TEMPLATE_URI}/${data.id}`, data, this.__ME_HEADERS)
      result.data.template = JSON.parse(result.data.template)
      return result.data
    } catch (e) {
      throw new Error('updateError')
    }
  }

  /**
   * Upload les images sur nos server
   * @param {Array} files tableau d'images
   */
  async uploadAllTemplateImages(arrayImages, progressFunction) {
    try {
      const formData = new FormData()
      arrayImages.forEach((file, index) => {
        formData.append(file.uid, file.blob)
      })
      const result = await Axios.post(UPLOAD_URI, formData, {
        headers: {
          ...this.__ME_HEADERS.headers,
          'X-Requested-With': 'XMLHttpRequest',
          'content-type': 'multipart/form-data'
        },
        onUploadProgress: progressEvent => progressFunction(progressEvent)
      })
      return result.data
    } catch (e) {
      throw new Error('uploadError')
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////
  // IMAGE_PROVIDER
  //////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
   * Charge les photo unsplash
   *
   * @param {string} [value='']
   * @param {number} [page=1]
   * @param {number} [count=21]
   * @memberof HttpConnector
   */
  async getUnsplahPictures(value = '', page = 1, count = 6) {
    let params = ''
    if (defined(value)) {
      value = encodeURI(value)
      params = `images?page=${page}&search=${value}&count=${count}`
    } else {
      params = `images?page=${page}&count=${count}`
    }
    const headers = {
      'X-Requested-With': 'XMLHttpRequest'
    }
    return Axios.get(`${IMAGE_PROVIDER}${params}`, {
      headers
    })
  }

  async pixabayBase64(url) {
    const img = await Axios.get(url, {
      responseType: 'blob'
    })
    return img.data
  }

  /**
   * Increment le téléchargement de la photo chez unsplash (condition d'utilisation de l'api)
   * @param {String} id id de la photo
   */
  unsplashDlIncrement(url) {
    return Axios.post(`${IMAGE_PROVIDER}download`, {
      url
    })
  }

  /**
   * recupère les settings de l'utilisateurs
   * **/
  async getSettings() {
    try {
      return await Axios.get(`${SETTINGS_URI}`, this.__ME_HEADERS)
    } catch (e) {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/model/http/HttpConnector.js